import React from "react";
import { Alert, Link } from "../../../../components";
import { envs, links } from "../../../../config";
import TextStyled from "./AlertSection.Style";

const AlertaSection = () => {
  return (
    <Alert>
      <TextStyled size="sm">
        <strong>Importante:</strong> se você contratou uma capitalização a
        partir de {envs.dataEntradaJV5}, seu acesso à área do cliente e outras
        informações estão em um novo ambiente.{" "}
        <Link href={links.capitalizacao.link1} label="Acesse aqui" />.
      </TextStyled>
    </Alert>
  );
};

AlertaSection.propTypes = {};

export default AlertaSection;
